import React from 'react'
import '../../../App.css';
import {Link} from 'react-router-dom';

export default function TicTacToe() {
    return(
        <>
            <Link to="/DigitalPortfolio/projects" className="nav-back">
                <div className='nav-back-text'>{"<"}Back</div>
            </Link>
            <h1 className='header'>Tic Tac Toe</h1>
        </>
    )
}